import { useState, useEffect } from 'react';
import { Platform } from 'react-native';
import { getIsAbleToPurchaseOnStorefront } from '../../utils/purchase';
const IS_WEB = Platform.OS === 'web';
export function useIsAbleToPurchaseOnStorefront() {
    const [isLoading, setIsLoading] = useState(!IS_WEB);
    const [isAble, setIsAble] = useState(IS_WEB);
    useEffect(() => {
        if (IS_WEB)
            return;
        async function run() {
            try {
                const result = await getIsAbleToPurchaseOnStorefront();
                setIsAble(result);
            }
            catch {
                setIsAble(false);
            }
            finally {
                setIsLoading(false);
            }
        }
        run();
    }, []);
    return {
        isAble,
        isLoading,
    };
}
//# sourceMappingURL=useIsAbleToPurchaseOnStorefront.js.map